import { getAppCheckToken, shouldUseAppCheck } from '../services/firebase/appCheck'

export const applyAppCheckToRequest = async (url: string, config: any) => {
  if (!shouldUseAppCheck(url)) {
    return config
  }

  try {
    const appCheckToken = await getAppCheckToken()

    if (appCheckToken) {
      config.headers = {
        ...config.headers,
        'X-Firebase-AppCheck': appCheckToken
      }
    }
  } catch (error) {
    console.error('Error applying App Check to request:', error)
  }

  return config
}
